const page       = require('../../../../../components/page/page')
const clientActivityDt = require('./clientActivity-dt')

import clientActivityPage       from "./clientActivity-page.html";


/****************ELEMENTS*****************/
var HTMLwasSelected  = false

//insert the page  on the body
function HTMLselect(detail){ 
	
	HTMLwasSelected = true

	//load the page to the index
   const body = document.body
   body.insertAdjacentHTML("beforeend", clientActivityPage)

   clientActivityDt.start({"dest":"clientActivity", "elem":"dt", "act":"select", "entity":"clientActivity"})

}/*init*/

/****************ELEMENTS*****************/
export function start(detail){ 
   if(!HTMLwasSelected) {HTMLselect(detail)}
	obj[detail.act].start(detail)
}

const obj = {
   
      show:  { start: (detail)=>{  page.start(detail)     }},
}/**/
